// removed by extract-text-webpack-plugin
module.exports = {"inputWrapperContainer":"_3ZmqLsvx1NMTgbp97W3o8l","inputWrapperContainerInner":"_12rY7FvS0jWKkerUHMKSWb","titleContainer":"_1zMlfGIJByxuN9xQR6bZHA","titleInner":"_3NzONV7OAtX0XN5Pfn5WEJ","socialFeed":"_2bcdQJAmUp31lBKHOq2qZy","btn":"_3Y7TqTCD5AVG4sxt3J38cK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/social/social.css
// module id = 168
// module chunks = 0